import { DefaultService } from '@/services/DefaultService';

export default class RotaVisitaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(rota) {
        return  this._http.post(`${this._env}/ven/routevisit`, rota, this._headers)
                    .then(res => res.body, this.handleError);
    }

    find(id) {
        return  this._http.get(`${this._env}/ven/routevisit/${id}.json`, this._headers)
                    .then(res => res.body, this.handleError);
    }

    delete(id) {
        return  this._http.delete(`${this._env}/ven/routevisit/${id}`, this._headers)
                    .then(res => res.body, this.handleError);
    }

    updateSituacao(rota) {
        return this._http.post(`${this._env}/ven/routevisit/updatesituacao`, rota, this._headers)
                    .then(res =>  res.body, this.handleError);
    }

    findAll(page = 0, limit = 50,situacao = 2, order = 'asc', column = 'descricao',...params) {
        return  this._http.get(encodeURI(`${this._env}/ven/routevisit.json?page=${page}&limit=${limit}&situacao=${situacao}&order=${order}&column=${column}&param=${params}`), this._headers)
                    .then(res => res.body, this.handleError);
    }

}